export default {
      id: "filter-usage",
      viewBox: "0 0 29 21",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#filter",
      toString: function () {
        return this.url;
      }
    }